var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-skeleton-loading "},[_c('van-loading',{attrs:{"tsize":"24px","vertical":""}}),_vm._v(" 加载中... "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }